<template>
  <v-dialog v-model="dialog" max-width="800" persistent>
    <v-card>
      <v-card-title>
        {{ $vuetify.lang.t('$vuetify.map.mapDialog.tripReportDialog.title') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>{{ closeIcon }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        {{ $vuetify.lang.t(cardText) }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red lighten-1" @click="sendRejectState">{{
          $vuetify.lang.t('$vuetify.map.mapDialog.tripReportDialog.reject') }}
        </v-btn>
        <v-btn text color="light-green" @click="sendConfirmState">{{
          $vuetify.lang.t('$vuetify.map.mapDialog.tripReportDialog.confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
  name: 'tripReportStateDialog',
  props: {
    dialog: Boolean,
    isReport: Boolean
  },
  computed: {
    cardText () {
      return this.isReport ? '$vuetify.map.mapDialog.tripReportDialog.excludeText' : '$vuetify.map.mapDialog.tripReportDialog.includeText'
    }
  },
  data: () => ({
    closeIcon: mdiClose
  }),
  methods: {
    closeDialog () {
      this.$emit('report-state-dialog-closed')
    },
    _sendState (state) {
      this.$emit(state)
      this.closeDialog()
    },
    sendRejectState () {
      this._sendState('report-state-dialog-reject')
    },
    sendConfirmState () {
      this._sendState('report-state-dialog-confirm')
    }
  }
}
</script>

<style scoped>

</style>
